var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingsIconBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_feather-settings",
    "data-name": "Icon feather-settings",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.495,
    height: 28.495,
    viewBox: "0 0 28.495 28.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10434",
    "data-name": "Path 10434",
    d: "M20.453,16.977A3.477,3.477,0,1,1,16.977,13.5,3.477,3.477,0,0,1,20.453,16.977Z",
    transform: "translate(-2.729 -2.729)",
    fill: "none",
    stroke: "#3cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10435",
    "data-name": "Path 10435",
    d: "M22.823,17.724a1.912,1.912,0,0,0,.382,2.109l.07.07A2.319,2.319,0,1,1,20,23.183l-.07-.07a1.928,1.928,0,0,0-3.268,1.367v.2a2.318,2.318,0,0,1-4.635,0v-.1a1.912,1.912,0,0,0-1.252-1.75,1.912,1.912,0,0,0-2.109.382l-.07.07A2.319,2.319,0,1,1,5.313,20l.07-.07a1.928,1.928,0,0,0-1.367-3.268h-.2a2.318,2.318,0,1,1,0-4.635h.1a1.912,1.912,0,0,0,1.75-1.252A1.912,1.912,0,0,0,5.29,8.662l-.07-.07A2.319,2.319,0,1,1,8.5,5.313l.07.07a1.912,1.912,0,0,0,2.109.382h.093a1.912,1.912,0,0,0,1.159-1.75v-.2a2.318,2.318,0,0,1,4.635,0v.1A1.928,1.928,0,0,0,19.833,5.29l.07-.07a2.319,2.319,0,1,1,3.28,3.28l-.07.07a1.912,1.912,0,0,0-.382,2.109v.093a1.912,1.912,0,0,0,1.75,1.159h.2a2.318,2.318,0,0,1,0,4.635h-.1a1.912,1.912,0,0,0-1.75,1.159Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#3cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIconBlue);
export default __webpack_public_path__ + "static/media/SettingsIconBlue.62fd7c4e3d2eb48896f4860fc87c70fe.svg";
export { ForwardRef as ReactComponent };